import React from "react";

// Stroke-only bottle illustration from the 2026 refresh artboards.
// `fill` tints the glass, `dark` flips it to the on-dark hero variant.
export default function WineBottle({ fill = "#DCE6E3", width = 62, dark = false, stroke }) {
  const height = Math.round((width * 260) / 120);
  const line = stroke || (dark ? "#00E5C7" : "#0C0E0E");
  return (
    <svg width={width} height={height} viewBox="0 0 120 260" fill="none" aria-hidden="true">
      <path
        d="M50 12 h20 v44 c0 10 6 14 12 22 6 8 9 17 9 27 v133 c0 7-5 12-12 12 H51 c-7 0-12-5-12-12 V105 c0-10 3-19 9-27 6-8 12-12 12-22 z"
        fill={dark ? "#1E2325" : fill}
        stroke={line}
        strokeWidth={dark ? 3 : 4}
      />
      <rect x="48" y="4" width="24" height="16" rx="3" fill={line} />
      <rect x="39" y="150" width="52" height="46" fill={dark ? "#00E5C7" : "#FFFFFF"} opacity={dark ? 0.14 : 1} />
      <path d="M39 150h52M39 196h52" stroke={line} strokeWidth={dark ? 2 : 4} />
      {!dark && <path d="M49 166h32" stroke="#00B9A3" strokeWidth="5" />}
    </svg>
  );
}
